import styled from 'styled-components';

import { FlexDiv, FadeIn, GenericP, BounceAnim, AngleArrow } from '../../../common/Styles';

export const ExploreWrapper = styled(FlexDiv)`
	position: fixed;
	bottom: 30px;
	left: 50%;
	transform: translateX(-50%);
	z-index: 8;
	animation : ${FadeIn} 1s ease-in-out forwards;
	background: transparent;
	cursor: pointer;
`;

export const ExploreTxt = styled(GenericP)`
	background: #102238;
	padding: 5px 10px;
	margin-bottom: 3px;
	opacity: 0.8;
	border-radius: 3px;
`;

export const ArrowWrap = styled.div`
	background: #102238;
	padding: 5px 10px;
	border-radius: 50%;
	width: 56px;
	height: 56px;
	text-align: center;
	opacity: 0.8;
`;

export const Arrows = styled.span`
	position: relative;
	width: 30px;
	height: 30px;
	animation: ${BounceAnim('10px', '-10px')} 1.5s ease-in-out infinite alternate;
  display: inline-block;
	margin-top: 10px;
`;

export const ExploreArrow = styled(AngleArrow)`
	display: inline-block;
	width: 17px;
	height: 17px;
	margin-top: ${(p)=>p.top_M || '0'}px;
	border-color: #ff684a;
	left: 0;
	right: auto;
	left: 7px;
`;
